import { DownloadCSV } from '../../core/slots/DownloadCSV.js';
import { DISPLAY_NAME } from '../constants/defaults.js';

export const HistogramChartDownloadCSVSlot = DownloadCSV(DISPLAY_NAME);
